import { create } from 'zustand';

interface IPermissionStore {
  permissions: string[];
  setPermissions: (newPermissions: string[]) => void;
  /** Hrefs liberados pelo backend (ex.: ['/cursos', '/disciplinas']). null = sem dado (libera tudo). */
  platformModules: string[] | null;
  setPlatformModules: (routes: string[] | null) => void;
}

const useAccessControlStore = create<IPermissionStore>((set) => ({
  permissions: [],
  setPermissions: (newPermissions) => set({ permissions: newPermissions }),
  platformModules: null,
  setPlatformModules: (routes) => set({ platformModules: routes }),
}));

const hasPermission = (modulesAllowed: string[]): boolean => {
  // const { permissions } = useAccessControlStore();
  return true;
};

export { useAccessControlStore, hasPermission };
